import Form from "@/components/Shared/Form";
import clsx from "classnames";
import { useRouter } from "next/router";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";
// import SocialShare from "@/components/Shared/SF_SocialShareCard_001";

import FooterWave2Icon from "@/public/site-assets/svg/footer-wave-2.svg";

export const SimpleFormWithColumn = ({
  className,
  heading,
  content,
  image,
  formId,
  successPageUrl,
  showWave,
  waveDirection,
  waveColor,
  waveBackground,
  showTopWave,
  topWaveDirection,
  topWaveColor,
  topWaveBackground,
}) => {
  const router = useRouter();

  const dynamicSuccessPageUrl =
    successPageUrl ||
    (() => {
      const currentPath = router.asPath;
      if (currentPath.includes("?")) {
        const [basePath, queryParams] = currentPath.split("?");
        return `${basePath}/thank-you?${queryParams}`;
      } else {
        return `${currentPath}/thank-you`;
      }
    })();

  return (
    <>
      {showTopWave && (
        <div
          className={clsx(
            "footer",
            topWaveDirection === "down" && "rotate",
            topWaveColor,
            topWaveBackground,
          )}
          style={{ marginBottom: "-1px", zIndex: 1, position: "relative" }}
        >
          <FooterWave2Icon />
        </div>
      )}
      <section className={clsx(className, styles.root)}>
        <Container>
          <div className="wrapper">
            <div>
              {heading && <h2 className={`h3 mb-3`}>{heading}</h2>}
              {content && (
                <div
                  className={`content`}
                  dangerouslySetInnerHTML={{
                    __html: content,
                  }}
                />
              )}
              {image && <img src={image?.url} alt={image?.alt} width={"100%"} />}
            </div>
            <div className="w-100">
              {formId && <Form formId={formId} successPageUrl={dynamicSuccessPageUrl} />}
            </div>
          </div>
        </Container>
        {showWave && (
          <div
            className={clsx(
              "footer",
              waveDirection === "down" && "rotate",
              waveColor,
              waveBackground,
            )}
            style={{ marginTop: "-1px" }}
          >
            <FooterWave2Icon />
          </div>
        )}
      </section>
    </>
  );
};

export default SimpleFormWithColumn;
